// extracted by mini-css-extract-plugin
export default {"f":"_8a3b1c2bf0","main":"_28d4708ac8","btn":"_1e3851a191","w":"_26253ad32e","h":"c336a071dc","lh25":"_0b9b2310a2","wb":"e38c2a7cdc","b":"_588b5b422c","bx":"b926d5a23f"};